import "./index.scss";

const ErrorPage = ({ onRetry }) => {
  return (
    <div className="error-page-container">
      <div className="error-page-content">
        <h1 className="error-page-title">Oops!</h1>
        <h2 className="error-page-subtitle">Something went wrong!</h2>
        <p className="error-page-description">
          We're sorry for the inconvenience. An unexpected error occurred.
          Please try refreshing the page or contact support if the problem
          persists.
        </p>
        <button className="error-page-button" onClick={onRetry}>
          Refresh Page
        </button>
      </div>
      <div className="error-page-background"></div>
    </div>
  );
};

export default ErrorPage;
